import { MotifCard, MotifCardBody, MotifChip, MotifChipGroup, MotifFileUploaderItem } from '@ey-xd/motif-react';
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux';

const ConversationParseingDocument = (props: any) => {
    const { content } = props;
    const dispatch = useDispatch();
    const renderProcessing = useCallback(() => {
        const { options } = content;
        return (
            <MotifFileUploaderItem
                aria-label="Item aria-label text"
                isIndeterminate
                onRemove={function Xo() { }}
                showProgress
            />
        )
    }, [])
    return (
        <MotifCard className="!w-full">
            <MotifCardBody>
                <p className="text-md">
                    {content.title}
                </p>
                {renderProcessing()}
            </MotifCardBody>
        </MotifCard>
    )
}

export default ConversationParseingDocument